
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"logo-loader-circle",attrs:{"cx":"48","cy":"48","r":"36"}}),_c('path',{staticClass:"logo-loader-left",attrs:{"d":"M43.6 34.03A157.173 157.173 0 0024.55 57C23.7 41.953 20.4 27.553 15 14a171.8 171.8 0 0130 18.635l-1.4 1.395z"}}),_c('path',{staticClass:"logo-loader-right",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M65.946 55.217c-4.215-3.075-9.584-4.96-15.455-4.96-6.674 0-12.745 2.43-17.111 6.299a158.264 158.264 0 0118.917-18.054 159.392 159.392 0 0119.018-13.194c-2.91 9.772-4.716 19.74-5.369 29.909zM25 57.597c6.824-8.332 14.602-15.97 23.183-22.865C58.118 26.697 69.158 19.753 81 14a135.21 135.21 0 00-9.634 43.548s-.05 0-.05.05C62.433 64.74 54.605 72.972 48.132 82 41.71 72.923 33.932 64.74 25 57.597z","fill":"#5E45B5"}})])
          )
        }
      }
    